const angular = require('angular');
const template = require('./subscription-warning.html');

import 'angular-modal-service';
import 'angular-sanitize';
import {SubscriptionWarningController} from './subscription-warning.controller';

class SubscriptionWarningModal {

    public static $inject = ['ModalService'];

    constructor(private ModalService) {}

    public show = ({acctServMessage, phone, status}) => {
        this.ModalService.showModal({
            template,
            controller: SubscriptionWarningController,
            controllerAs: 'ctrl',
            inputs: {acctServMessage, phone, status}
        });
    }
}

export default angular
    .module('spsng.modals.subscription-warning', ['angularModalService','ngSanitize'])
    .service('SubscriptionWarningModal', SubscriptionWarningModal)
    .name;
